import { render, staticRenderFns } from "./Top10Product.vue?vue&type=template&id=6015880e&scoped=true&"
import script from "./Top10Product.vue?vue&type=script&lang=js&"
export * from "./Top10Product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6015880e",
  null
  
)

export default component.exports